import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { of } from 'rxjs/observable/of';
import { LookupsService, UsersService } from '../../data';
import * as lookupActions from '../actions/lookup.actions';

@Injectable()
export class LookupEffects {
  constructor(private actions$: Actions, private lookupsService: LookupsService) { }

  @Effect()
  loadLicenseTypes$ = this.actions$.ofType(lookupActions.LookupActionTypes.LoadLicenseTypes)
    .switchMap(() => {
      return this.lookupsService.getCompanyLicenseTypes()
        .map(list => new lookupActions.LoadLicenseTypesSuccess(list))
        .catch(error => of(new lookupActions.LoadLicenseTypesFail(error)));
    });

  @Effect()
  loadContactTypes$ = this.actions$.ofType(lookupActions.LookupActionTypes.LoadContactTypes)
    .switchMap(() => {
      return this.lookupsService.getContactTypes()
        .map(list => new lookupActions.LoadContactTypesSuccess(list))
        .catch(error => of(new lookupActions.LoadContactTypesFail(error)));
    });

  @Effect()
  loadCountries$ = this.actions$.ofType(lookupActions.LookupActionTypes.LoadCountries)
    .switchMap(() => {
      return this.lookupsService.getCountries()
        .map(list => new lookupActions.LoadCountriesSuccess(list))
        .catch(error => of(new lookupActions.LoadCountriesFail(error)));
    });

  @Effect()
  loadIdTypes$ = this.actions$.ofType(lookupActions.LookupActionTypes.LoadIDTypes)
    .switchMap(() => {
      return this.lookupsService.getIdTypes()
        .map(list => new lookupActions.LoadIDTypesSuccess(list))
        .catch(error => of(new lookupActions.LoadIDTypesFail(error)));
    });

  @Effect()
  loadVenueTypes$ = this.actions$.ofType(lookupActions.LookupActionTypes.LoadVenueTypes)
    .switchMap(() => {
      return this.lookupsService.getVenueTypes()
        .map(list => new lookupActions.LoadVenueTypesSuccess(list))
        .catch(error => of(new lookupActions.LoadVenueTypesFail(error)));
    });

  @Effect()
  loadAccessCardTypes$ = this.actions$.ofType(lookupActions.LookupActionTypes.LoadAccessCardTypes)
    .switchMap(() => {
      return this.lookupsService.getAccessCardTypes()
        .map(list => new lookupActions.LoadAccessCardTypesSuccess(list))
        .catch(error => of(new lookupActions.LoadAccessCardTypesFail(error)));
    });

  @Effect()
  loadRequestAccessCardReasons$ = this.actions$.ofType(lookupActions.LookupActionTypes.LoadRequestAccessCardReasons)
    .switchMap(() => {
      return this.lookupsService.getRequestAccessCardReasons()
        .map(list => new lookupActions.LoadRequestAccessCardReasonsSuccess(list))
        .catch(error => of(new lookupActions.LoadRequestAccessCardReasonsFail(error)));
    });

  @Effect()
  loadChargeTypes$ = this.actions$.ofType(lookupActions.LookupActionTypes.LoadChargeTypes)
    .map((action: lookupActions.LoadChargeTypes) => action.payload)
    .switchMap(groupId => {
      return this.lookupsService.getChargeTypes(groupId)
        .map(list => new lookupActions.LoadChargeTypesSuccess(list))
        .catch(error => of(new lookupActions.LoadChargeTypesFail(error)));
    });

  @Effect()
  loadUsers$ = this.actions$.ofType(lookupActions.LookupActionTypes.LoadUsers)
    .switchMap(() => {
      return this.lookupsService.getUsers()
        .map(list => new lookupActions.LoadUsersSuccess(list))
        .catch(error => of(new lookupActions.LoadUsersFail(error)));
    });

  @Effect()
  loadAccessCardCancellationReason$ = this.actions$.ofType(lookupActions.LookupActionTypes.LoadAccessCardCancellationReason)
    .switchMap(() => {
      return this.lookupsService.getAccessCardCancellationReason()
        .map(list => new lookupActions.LoadAccessCardCancellationReasonSuccess(list))
        .catch(error => of(new lookupActions.LoadAccessCardCancellationReasonFail(error)));
    });

  @Effect()
  loadRequestStatus$ = this.actions$.ofType(lookupActions.LookupActionTypes.LoadRequestStatus)
    .switchMap(() => {
      return this.lookupsService.getRequestStatusAll()
        .map(list => new lookupActions.LoadRequestStatusSuccess(list))
        .catch(error => of(new lookupActions.LoadRequestStatusFail(error)));
    });
}



// WEBPACK FOOTER //
// ./src/app/core/store/effects/lookup.effects.ts